import {
  Box,
  Container,
  SimpleGrid,
  Flex,
  Image,
  Text,
  Link,
  VStack,
} from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { FaInstagram, FaTiktok } from "react-icons/fa";
import { Icon } from "@chakra-ui/react";
import logo from "../assets/logo.png";
import { useCategories } from "../hooks/useCategories";

const Footer = () => {
  const { categories } = useCategories();
  const shopLinks = categories
    .slice(0, 5)
    .map((c) => [c.name, `/category/${c.slug}`] as const);

  return (
    <Box as="footer" borderTop="1px solid" borderColor="rs.border">
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <SimpleGrid columns={{ base: 2, md: 4 }} gap={10} py={12}>
          <Box gridColumn={{ base: "1 / -1", md: "auto" }}>
            <Flex align="center" gap={2} mb={4}>
              <Image
                src={logo}
                alt="Red Shutter"
                height="140px"
                objectFit="contain"
              />
            </Flex>
            <Text
              fontSize="12.5px"
              color="rs.textDim"
              lineHeight="1.75"
              maxW="220px"
            >
              Professional photography equipment, rentals, and repair in
              Kandy, Sri Lanka.
            </Text>
          </Box>

          <Box>
            <Text
              fontSize="10.5px"
              fontWeight="600"
              letterSpacing="0.13em"
              textTransform="uppercase"
              color="rs.textDim"
              mb={4}
            >
              Shop
            </Text>
            <VStack align="flex-start" spacing={3}>
              {shopLinks.map(([label, href]) => (
                <Link
                  key={label}
                  as={RouterLink}
                  to={href}
                  fontSize="13px"
                  color="rs.textMuted"
                  _hover={{ color: "rs.text" }}
                >
                  {label}
                </Link>
              ))}
            </VStack>
          </Box>

          <Box>
            <Text
              fontSize="10.5px"
              fontWeight="600"
              letterSpacing="0.13em"
              textTransform="uppercase"
              color="rs.textDim"
              mb={4}
            >
              Services
            </Text>
            <VStack align="flex-start" spacing={3}>
              <Link
                as={RouterLink}
                to="/#rent"
                fontSize="13px"
                color="rs.textMuted"
                _hover={{ color: "rs.text" }}
              >
                Rent equipment
              </Link>
              <Link
                as={RouterLink}
                to="/#contact"
                fontSize="13px"
                color="rs.textMuted"
                _hover={{ color: "rs.text" }}
              >
                Repair and service
              </Link>
            </VStack>
          </Box>

          <Box>
            <Text
              fontSize="10.5px"
              fontWeight="600"
              letterSpacing="0.13em"
              textTransform="uppercase"
              color="rs.textDim"
              mb={4}
            >
              Contact
            </Text>
            <VStack align="flex-start" spacing={3}>
              <Link
                href="tel:+94765420007"
                fontSize="13px"
                color="rs.textMuted"
                _hover={{ color: "rs.text" }}
              >
                (76) 542 0007
              </Link>
              <Link
                href="mailto:redshuttermedia16@gmail.com"
                fontSize="13px"
                color="rs.textMuted"
                _hover={{ color: "rs.text" }}
              >
                redshuttermedia16@gmail.com
              </Link>
              <Flex gap={3} pt={1}>
                <Link
                  href="https://www.instagram.com/redshuttercamerastore/"
                  isExternal
                  color="rs.textMuted"
                  _hover={{ color: "rs.red" }}
                  aria-label="Instagram"
                >
                  <Icon as={FaInstagram} boxSize={4} />
                </Link>
                <Link
                  href="https://www.tiktok.com/@redshuttercameras"
                  isExternal
                  color="rs.textMuted"
                  _hover={{ color: "rs.red" }}
                  aria-label="TikTok"
                >
                  <Icon as={FaTiktok} boxSize={4} />
                </Link>
              </Flex>
            </VStack>
          </Box>
        </SimpleGrid>

        <Flex
          justify="space-between"
          align="center"
          py={5}
          borderTop="1px solid"
          borderColor="rs.border"
          gap={4}
          flexWrap="wrap"
        >
          <Text fontSize="11px" color="rs.textDim">
            © 2026 Red Shutter Camera Store
          </Text>
          <Text
            fontSize="11px"
            color="rs.textDim"
            textAlign={{ base: "left", md: "right" }}
          >
            71.1, 1st Floor, City Plaza Shopping Complex, Kandy 20000
          </Text>
        </Flex>
      </Container>
    </Box>
  );
};

export default Footer;
